import { UserApplicationForm } from '@app/application/components/UserApplicationForm';

export const UserFormPage = () => {
  return <UserApplicationForm />;
};
